import { BaseApi } from './base';

class SupportApi extends BaseApi {
  constructor() {
    super('support');
  }

  sendSupportMessage(data) {
    return this.post('', data);
  }
}

export default new SupportApi();
